import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { checkIsLoading } from 'src/utils/types/statuses';

import { AvailableForCheckboxes } from './AvailableForCheckboxes';
import { checkCanLoadAvailable } from 'src/store/lists/availableForAppearancesIn/helpers';
import { fetchAvailableForAppearancesIn } from 'src/store/lists/availableForAppearancesIn/asyncThunk';

type PAvailableCheckboxesContainer = {
  errorText?: any;
  value: Array<number>;
  onChange: any;
  [key: string]: any;
};

export const AvailableForCheckboxesContainer: React.FC<PAvailableCheckboxesContainer> =
  (props) => {
    const { ...otherProps } = props;
    const { status, data } = useSelector(
      (state: RootState) => state.availableForAppearancesIn,
    );

    const dispatch = useDispatch();
    useEffect(() => {
      checkCanLoadAvailable(() => dispatch(fetchAvailableForAppearancesIn()));
    }, [dispatch]);

    return (
      <AvailableForCheckboxes
        label="Available for appearances in"
        loading={checkIsLoading(status)}
        data={data}
        {...otherProps}
      />
    );
  };
